<script lang="ts">
  import { _ } from 'svelte-i18n';
  
  export let isOpen = false;
  export let title: string;
  export let message: string;
  export let onConfirm: () => void;
  export let onCancel: () => void;
</script>

{#if isOpen}
<!-- svelte-ignore a11y-no-static-element-interactions -->
<dialog open>
  <article>
      <header>
        <button aria-label="Close" class="close" on:click={onCancel}></button>
        <h3>{title}</h3>
      </header>
      <p>{message}</p>

    <footer class="flex space-between">
      <button type="button" class="secondary" on:click={onCancel}>
        {$_('common.cancel')}
      </button>
      <button type="button" on:click={onConfirm}>
        {$_('common.delete')}
      </button>
    </footer>
  </article>
</dialog>
{/if}

<style>
</style> 